module.exports = __webpack_public_path__ + "img/sos.19621539.png";